<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Locked service accounts</h1>

                    <a v-sanitizedHref="`/#/admin/organizations/users/service-accounts/${tid}`" type="button" class="btn btn-link btn-sm">
                        <i class="fa fa-cog" aria-hidden="true"></i>
                        <span>Active service accounts</span>
                    </a>

                    <a v-sanitizedHref="`/#/admin/organizations/users/service-accounts/deleted/${tid}`" type="button" class="btn btn-link btn-sm">
                        <i class="fa fa-user-times" aria-hidden="true"></i>
                        <span>Deleted service accounts</span>
                    </a>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <p class="text-muted">Locked service accounts that have been blocked from API access.</p>
            <UsersTable v-if="lockedServiceAccounts.length" :users="lockedServiceAccounts"></UsersTable>
            <h4 v-else>No locked service accounts</h4>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, mixins } from 'vue-facing-decorator';
    import PageBase from "@common/PageBase";
    import VuePageQueries from "@Organizations/Users/queries-vue-component";
    import VuePageCommands from "@Organizations/Users/commands-vue-component";
    import "@common/AdminNavigationV2.vue";
    import "@Organizations/Users/Components/UsersTable.vue";

    @Component
    export default class LockedServiceAccountsPage extends mixins(PageBase, VuePageQueries, VuePageCommands) {
        mounted() {
            this.setTitle("Locked service accounts");
            // Include active=false, locked=true, deleted=false, includeServiceAccounts=true
            this.runSearchAllUsersQueryV1(this.tid, '', false, true, false, true);
        }

        get allUsersSearchResult() { return this.model?.AllUsersSearchResult; }
        get users() { return this.allUsersSearchResult?.Users || []; }
        get lockedServiceAccounts() { return this.users; }
    }
</script>

<style scoped>
</style>
